import { createContext, useContext } from 'react';

export enum TcsoDualFuelScreen {
  TCSO_DUAL_FUEL_CHECKLIST_SCREEN,
  TCSO_DUAL_FUEL_METER_DETAILS_SCREEN,
}

export interface TcsoDualFuelInputs {
  mpan: string;
  mprn: string;
  elecMsn: string;
  gasMsn: string;
}

interface TcsoDualFuelContextProps {
  tcsoDualFuelInputs: TcsoDualFuelInputs;
  setTcsoDualFuelInputs: (tcsoDualFuelState: TcsoDualFuelInputs) => void;
}

export const tcsoDualFuelInitialState: TcsoDualFuelInputs = {
  mpan: '',
  mprn: '',
  elecMsn: '',
  gasMsn: '',
};

export const TcsoDualFuelContext = createContext<TcsoDualFuelContextProps>({
  tcsoDualFuelInputs: tcsoDualFuelInitialState,
  setTcsoDualFuelInputs: () => {},
});

export const useTcsoDualFuelContext = (): TcsoDualFuelContextProps => {
  const context = useContext(TcsoDualFuelContext);
  if (!context) {
    throw new Error('useTcsoDualFuelContext must be used within a TcsoDualFuelProvider');
  }
  return context;
};

export interface TcsoDualFuelScreenInputs {
  tcsoDualFuelScreen: TcsoDualFuelScreen;
}

interface TcsoDualFuelScreenContextProps {
  tcsoDualFuelScreenInputs: TcsoDualFuelScreenInputs;
  setTcsoDualFuelScreenInputs: (tcsoDualFuelScreenState: TcsoDualFuelScreenInputs) => void;
}

export const TcsoDualFuelScreenContext = createContext<TcsoDualFuelScreenContextProps>({
  tcsoDualFuelScreenInputs: { tcsoDualFuelScreen: TcsoDualFuelScreen.TCSO_DUAL_FUEL_CHECKLIST_SCREEN },
  setTcsoDualFuelScreenInputs: () => {},
});

export const useTcsoDualFuelScreenContext = (): TcsoDualFuelScreenContextProps => {
  const context = useContext(TcsoDualFuelScreenContext);
  if (!context) {
    throw new Error('useTcsoDualFuelScreenContext must be used within a TcsoDualFuelScreenProvider');
  }
  return context;
};
